import { useEffect, useState } from 'react'
import { measureImage } from '~/helpers/measureImage'

// Loads the image off-DOM and reports its intrinsic width / height. The ratio
// is the same whichever size variant is requested, so callers can pass a small
// one to keep the probe cheap.
export const useImageAspectRatio = (src: string | undefined) => {
  const [aspectRatio, setAspectRatio] = useState<number>()

  useEffect(() => {
    if (!src) {
      setAspectRatio(undefined)

      return undefined
    }

    let cancelled = false

    measureImage(src).then((image) => {
      if (cancelled) {
        return
      }

      setAspectRatio(image ? image.width / image.height : undefined)
    })

    return () => {
      cancelled = true
    }
  }, [src])

  return aspectRatio
}
